import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import moment from "moment";
import "moment/locale/pt-br";
import {
  descricaoFilialMatrix,
  descricaoSituacaoCadastral,
  UFPorExtenso,
} from "../../utils/CodigoParaDescricao";
import { ExportToCsv } from "export-to-csv";
import { ModalConfirm } from "../../components/ModalConfirm";
import FileDownload from "../../assets/FileDownload.svg";

import { textFilter } from "react-bootstrap-table2-filter";
import FormControl from "react-bootstrap/FormControl";
import Collapse from "react-bootstrap/Collapse";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";

import { formatNumberMongoDBToReal } from "../../utils/formatNumberToReal";

import TagFilter from "../../components/TagsInput/tagsFilter/TagFilter";
import CheckBoxFilter from "../../components/CheckboxFilter";
import TableResults from "../../components/TableResults";
import ModalAguarde from "../../components/CardAguarde";

//utils
import { MontaDescircaoFiltros } from "../../utils/montaDescricaoFiltrosPesquisa";
//import { ObjectParamFind, findDinamico } from "../../utils/APIFindDinamico"
import { removeMunicipiosTags } from "../../utils/remontaTagsMunicipio";
import Noselect from "../../utils/noSelect";

//icones e imagens
// import EstrelaDesabilitada from "../../assets/estrela_off.svg";
import InicioPesquisa from "../../assets/inicio_de_pesquisa.svg";
// import Estrela from "../../assets/estrela.svg";
import Expandir from "../../assets/expandir.svg";
import Recolher from "../../assets/recolher.svg";
import { AiOutlineUser } from "react-icons/ai";
import Lixeira from "../../assets/Lixeira.svg";
import Lupa from "../../assets/Lupa.svg";
import { useSnackbar } from "notistack";
import HistoricoService from "../../services/historicoService";
import { getArrayMunicipios } from "../../data/municipios";
import EmpresaService from "../../services/empresaService";
import ExtratoCreditosService from "../../services/extratoCreditosService";
import CnaeService from "../../services/cnaeService";
import { getArrayEstados } from "../../data/estados";

import "./pesquisaStyledPage.css";
import TopBarHeader from "../../components/TopBarHeader";

const listEstadosAutocomplete = getArrayEstados();

export default function Pesquisa() {
  let history = useHistory();
  const [buscouHistorico, setBuscouHistorico] = useState(false);
  const [cookies, setCookie] = useCookies("");
  const token = localStorage.getItem("TOKEN");
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [popupAguarde, setPopupAguarde] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(true);
  const [raizCNPJ, setRaizCNPJ] = useState(cookies.raizCnpj);
  const cnpjLogado = localStorage.getItem("CNPJ");
  const [listMunicipiosAutocomplete, setListMunicipiosAutcomplete] = useState(
    []
  );
  const [findResult, setFindResult] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [listarEmpresasDaBase, setListarEmpresasDaBase] = useState(false);
  const [desconsidEmpReservada, setDesconsidEmpReservada] = useState(false);
  const [desconsidEmpContatadaUmAno, setDesconsidEmpContatadaUmAno] =
    useState(false);
  const [apenasEmpresasAtivas, setApenasEmpresasAtivas] = useState(false);
  const [listarFiliais, setListarFiliais] = useState(false);
  const [tagsMunicipio, setTagsMunicipio] = useState([]);
  const [capitalSocial, setCapitalSocial] = useState("");
  const [anosFind, setAnosFind] = useState("");
  const [porteEmpresa, setPortEmpresa] = useState("");
  const [razaoSocial, setRazaoSocial] = useState("");
  const [formadetributacao, setFormadetributacao] = useState("");

  //Lucro Arbitrado, Lucro Presumido e Lucro Real
  const [tagsEstado, setTagsEstado] = useState([]);
  const [nomeSocio, setNomeSocio] = useState("");
  const [tagsCNAE, setTagsCNAE] = useState([]);
  const [listCNAEsAutocomplete, setListCNAEsAutocomplete] = useState([]);
  const [permissao] = useState(localStorage.getItem("LIBERADO_PORTAL"));
  const [historicoIndex, setHistoricoIndex] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [objectFindMais, setObjectFindMais] = useState(null);
  const [disableVerMais, setDisableVerMais] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const filtersChangedRef = useRef(false);

  const filter = MontaDescircaoFiltros(
    razaoSocial,
    capitalSocial,
    tagsMunicipio,
    tagsEstado,
    tagsCNAE,
    porteEmpresa,
    nomeSocio,
    raizCNPJ,
    listarEmpresasDaBase,
    listarFiliais,
    apenasEmpresasAtivas,
    cnpjLogado
  );
  const openModal = () => {
    setShowModalConfirm((prev) => !prev);
  };
  const exportCSV = () => {
    openModal();
  };
  var columnsTable = [
    {
      dataField: "razaoSocial",
      text: "Razão Social  ",
      filter: textFilter(),
    },
    {
      dataField: "municipio",
      text: "Município:  ",
      filter: textFilter(),
      formatter: (cell, row) => {
        return (
          <p>
            {row.uf} / {row.municipio}
          </p>
        );
      },
    },
    {
      dataField: "",
      text: "",
      align: (cell, row, rowIndex, colIndex) => {
        return "center";
      },
      formatter: (cell, row) => {
        return (
          <Button
            title="Extrato Completo"
            className="buttons"
            onClick={() => historyPushRedirect(row.cnpj)}
          >
            <AiOutlineUser /> Extrato
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (confirm) {
      const creditosPesquisa = findResult.map(() => {}).length;

      ExtratoCreditosService.postExtratoCreditos({
        creditosUtilizados: creditosPesquisa,
        tipo: "csv",
      })
        .then((res) => {
          enqueueSnackbar("Download realizado com sucesso!", {
            variant: "success",
          });
          csvFileGenerator();
        })
        .catch((error) => {
          enqueueSnackbar("Ocorreu um erro ao realizar", {
            variant: "error",
          });
        })
        .finally(() => {});

      function csvFileGenerator() {
        const filename = "PM_" + moment().format("DD-MM-YYYY_HH-mm-ss");

        const data = findResult.map((obj) => ({
          razaoSocial: obj.razaoSocial,
          cnpj: obj.cnpj,
          fantasia: obj.fantasia,
          identificadorMF:
            obj.identificadorMF.length === 0
              ? ""
              : descricaoFilialMatrix(obj.identificadorMF),
          situacaoCadastral:
            obj.situacaoCadastral.length === 0
              ? ""
              : descricaoSituacaoCadastral(obj.situacaoCadastral),
          capitalSocial: formatNumberMongoDBToReal(obj.capitalSocial),
          telefone1:
            obj.telefone1.length === 0
              ? ""
              : "(" + obj.dddTelefone1 + ") " + obj.telefone1,
          endereco: obj.logradouro + ", " + obj.numeroLogradouro,
          complementoLogradouro: obj.complementoLogradouro,
          bairro: obj.bairro,
          cep: obj.cep,
          municipio: obj.municipio,
          uf:
            obj.municipio === "EXTERIOR" || obj.uf.length === 0
              ? ""
              : UFPorExtenso(obj.uf),
          email: obj.email,
          porteEmpresa: obj.porteEmpresa,
          cnae: obj.cnaeDescricao,
        }));

        const headers = [
          "Razão Social",
          "CNPJ",
          "Nome Fantasia",
          "IdentificadorMF",
          "Situação Cadastral",
          "Capital Social",
          "Telefone",
          "Logradouro",
          "Complemento Logradouro",
          "Bairro",
          "CEP",
          "Município",
          "Estado",
          "Email",
          "Porte Empresa",
          "Formade Tributacao",
          "Cnae",
        ];

        const options = {
          filename: filename,
          showLabels: true,
          fieldSeparator: ";",
          useBom: true,
          headers: headers,
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
      }
    } else {
      return;
    }

    setConfirm(false);
  }, [confirm, findResult]);

  useEffect(() => {
    if (permissao !== "S") {
      history.push("/pm/empresa");
    }
  }, [history, permissao]);

  useEffect(() => {
    // Sempre que algum filtro mudar, a próxima busca deve iniciar na página 1.
    filtersChangedRef.current = true;
    setPageNumber(1);
    setObjectFindMais(null);
    setDisableVerMais(true);
  }, [
    razaoSocial,
    capitalSocial,
    tagsMunicipio,
    tagsEstado,
    tagsCNAE,
    porteEmpresa,
    nomeSocio,
    listarEmpresasDaBase,
    desconsidEmpReservada,
    listarFiliais,
    apenasEmpresasAtivas,
    formadetributacao,
    anosFind,
    desconsidEmpContatadaUmAno,
    raizCNPJ,
  ]);

  useEffect(() => {
    const buscaCnaes = async () => {
      const cnaes = await CnaeService.getCnaeAutoComplete();

      setListCNAEsAutocomplete(cnaes);
    };

    if (listCNAEsAutocomplete.length === 0) {
      buscaCnaes();
    }

    const buscaHistorico = async () => {
      var objectFilters = {};

      if (buscouHistorico === false) {
        setBuscouHistorico(true);

        var filters = await HistoricoService.getHistoricoAutoComplete();
        if (filters.indexGraphGeo !== undefined) {
          setHistoricoIndex(filters.indexGraphGeo);
        } else {
          setHistoricoIndex(0);
        }
        if (filters !== undefined) {
          objectFilters = HistoricoService.ajustaParametros(filters);

          setRazaoSocial(objectFilters.razaoSocial);
          setPortEmpresa(objectFilters.porteEmpresa);
          setFormadetributacao(objectFilters.formadetributacao);
          setAnosFind(objectFilters.anosFind);
          setCapitalSocial(objectFilters.capitalSocial);

          setTagsEstado(
            !!objectFilters.tagsEstado ? objectFilters.tagsEstado : []
          );

          if (!!objectFilters.tagsCnaes) setTagsCNAE(objectFilters.tagsCnaes);

          if (!!objectFilters.tagsMunicipio)
            setTagsMunicipio(objectFilters.tagsMunicipio);

          setListarFiliais(objectFilters.listarFiliais);
          setListarEmpresasDaBase(
            objectFilters.listarEmpresasDaBase === undefined
              ? false
              : objectFilters.listarEmpresasDaBase
          );

          setApenasEmpresasAtivas(objectFilters.listarEmpresasNaoAtivas);

          setNomeSocio(objectFilters.nomeSocio);
          setListMunicipiosAutcomplete(
            getArrayMunicipios(objectFilters.tagsEstado)
          );

          if (!!filters.objectResult)
            setFindResult(
              !!filters.objectResult.data ? filters.objectResult.data : []
            );
        } else {
          if (cookies !== undefined) {
            objectFilters = HistoricoService.ajustaParametros(cookies);
            setRazaoSocial(objectFilters.razaoSocial);
            setPortEmpresa(objectFilters.porteEmpresa);
            setFormadetributacao(objectFilters.formadetributacao);

            setCapitalSocial(objectFilters.capitalSocial);
            setTagsCNAE(objectFilters.tagsCnaes);
            setTagsEstado(objectFilters.tagsEstado);
            setListMunicipiosAutcomplete(
              getArrayMunicipios(objectFilters.tagsEstado)
            );
            setTagsMunicipio(objectFilters.tagsMunicipio);
            setListarFiliais(objectFilters.listarFiliais);
            setListarEmpresasDaBase(objectFilters.listarEmpresasDaBase);
            setApenasEmpresasAtivas(objectFilters.listarEmpresasNaoAtivas);
            setNomeSocio(objectFilters.nomeSocio);
          }
        }
      }
    };

    buscaHistorico();
  }, [listCNAEsAutocomplete.length, token, buscouHistorico, cookies]);

  function handleDelete(i, typeList) {
    switch (typeList) {
      case "CNAE":
        const tagsCnaes = tagsCNAE.slice(0);
        tagsCnaes.splice(i, 1);
        setTagsCNAE(tagsCnaes);
        break;
      case "ESTADO":
        const tagsEstados = tagsEstado.slice(0);
        tagsEstados.splice(i, 1);
        setTagsEstado(tagsEstados);
        setTagsMunicipio(removeMunicipiosTags(tagsEstados, tagsMunicipio));
        break;
      case "MUNICIPIO":
        const tagsMunicipios = tagsMunicipio.slice(0);
        tagsMunicipios.splice(i, 1);
        setTagsMunicipio(tagsMunicipios);
        break;
      default:
    }
  }

  const maisEmpresas = () => {
    if (objectFindMais !== null) {
      setPageNumber((prev) => {
        setObjectFindMais({ ...objectFindMais, pageNumber: pageNumber });
        setPageNumber(pageNumber + 1);
      });
    }
  };

  useEffect(() => {
    const chamaEmpresa = async () => {
      const empresas = await EmpresaService.getEmpresas(objectFindMais);

      // Só faz concat se for "mais resultados" (página > 1)
      if (objectFindMais.pageNumber > 1) {
        setFindResult(findResult.concat(empresas.data));
      } else {
        setFindResult(empresas.data);
      }

      if (empresas.data.length === 0) {
        setDisableVerMais(true);
      }
    };

    if (objectFindMais !== null) {
      if (objectFindMais.pageNumber !== undefined) {
        chamaEmpresa();
      }
    }
  }, [objectFindMais]);

  function handleAddition(tag, typeList) {
    switch (typeList) {
      case "CNAE":
        const tagsCnaes = [].concat(tagsCNAE, tag);
        setTagsCNAE(tagsCnaes);
        break;
      case "ESTADO":
        const tagsEstados = [].concat(tagsEstado, tag);
        setTagsEstado(tagsEstados);
        setListMunicipiosAutcomplete(getArrayMunicipios(tagsEstados));
        break;
      case "MUNICIPIO":
        const tagsMunicipios = [].concat(tagsMunicipio, tag);
        setTagsMunicipio(tagsMunicipios);
        break;
      default:
    }
  }

  async function handleFind(execFindApi) {
    setListMunicipiosAutcomplete(getArrayMunicipios(tagsEstado));

    const shouldResetPage = filtersChangedRef.current;
    // Usa um valor local para evitar race condition do setState assíncrono.
    const requestPageNumber = shouldResetPage ? 1 : pageNumber;
    if (shouldResetPage) {
      filtersChangedRef.current = false;
      setPageNumber(1);
    }

    var objectFind = {};

    if ((raizCNPJ !== "undefined") & (raizCNPJ !== undefined)) {
      objectFind.raizCNPJ = raizCNPJ;
    } else {
      objectFind = EmpresaService.ObjectParamFind(
        razaoSocial,
        capitalSocial,
        tagsMunicipio,
        tagsEstado,
        tagsCNAE,
        porteEmpresa,
        nomeSocio,
        listarEmpresasDaBase,
        desconsidEmpReservada,
        listarFiliais,
        apenasEmpresasAtivas,
        formadetributacao,
        anosFind,
        requestPageNumber,
        desconsidEmpContatadaUmAno
      );
      setObjectFindMais(objectFind);
      setPageNumber(requestPageNumber + 1);
      setDisableVerMais(false);
    }

    setPopupAguarde(true);
    let findResults;
    if (execFindApi) {
      findResults = await EmpresaService.getEmpresas(objectFind);
      setFindResult(findResults.data);
    } else {
      findResults = { data: findResult };
    }

    setPopupAguarde(false);
    if (findResults === "null") {
      alert("Não foi possível localizar nenhuma empresa!");
    } else {
      setCollapseOpen(false);
      var objectTags = {};
      objectTags.tagsCnaes = tagsCNAE;
      objectTags.tagsEstado = tagsEstado;
      objectTags.tagsMunicipio = tagsMunicipio;

      if (raizCNPJ === "undefined") {
        findResults = { data: findResults.data.slice(0, 5) };
        HistoricoService.postHistoricoPesquisa(
          objectFind,
          objectTags,
          findResults,
          historicoIndex
        );
      }
    }

    setCookie("raizCnpj", "undefined", { path: "/" });
    setRaizCNPJ("undefined");
  }

  function historyPushRedirect(p_cnpj) {
    setCookie("cnpjExtrato", p_cnpj, { path: "/" });

    //history.push('pm//empresa');
    const win = window.open("empresa", "_blank");
    win.focus();
  }

  function keyPressedEnter(event) {
    if (event.key === "Enter") {
      handleFind(true);
    }
  }
  // const addCliente = async (cnpj, rowIndex) => {
  //   const postCliente = await ClienteService.postCliente(cnpj);
  //   if (!!postCliente) {
  //     findResult[rowIndex].cliente = true;
  //     setFindResult(findResult);
  //     handleFind(false);
  //   }
  // };

  // const removeCliente = async (cnpj, rowIndex) => {
  //   const postRemoveCliente = await ClienteService.postRemoveCliente(cnpj);
  //   if (!!postRemoveCliente) {
  //     findResult[rowIndex].cliente = false;
  //     setFindResult(findResult);
  //     handleFind(false);
  //   }
  // };

  function cleanFilters() {
    setRazaoSocial("");
    setPortEmpresa("");
    setFormadetributacao("");
    setAnosFind("");
    setCapitalSocial("");
    setTagsCNAE([]);
    setTagsEstado([]);
    setTagsMunicipio([]);
    setListarFiliais(false);
    setListarEmpresasDaBase(false);
    setApenasEmpresasAtivas(false);
    setNomeSocio("");
    setFindResult([]);
  }

  console.log(cnpjLogado);

  const expandRow = {
    renderer: (row) => (
      <Card border="primary">
        <Card.Header>Informações Complementares</Card.Header>
        <Card.Body>
          <Card.Text>
            <p>
              Fantasia: <b>{` ${row.fantasia}`}</b>
            </p>
          </Card.Text>
          <Button
            variant="primary"
            size="sm"
            active
            onClick={() => historyPushRedirect(row.cnpj)}
          >
            Extrato Completo
          </Button>
        </Card.Body>
      </Card>
    ),
  };
  return (
    <>
      <ModalConfirm
        showModalConfirm={showModalConfirm}
        setShowModalConfirm={setShowModalConfirm}
        setConfirm={setConfirm}
        message={"Deseja realizar o download?"}
      />
      <ModalAguarde
        popupLoadVisible={popupAguarde}
        message=" Aguarde enquanto buscamos as empresas!"
      />
      <TopBarHeader title="Consulta de empresas" subtitle="Lista de empresas" />

      <Card className="text-left">
        <Card.Header>Filtros</Card.Header>
        <Card.Body>
          <Form onKeyPress={(e) => keyPressedEnter(e)}>
            <Collapse in={collapseOpen}>
              <div>
                <Form.Group>
                  <Form.Label>Razão Social:</Form.Label>
                  <Form.Control
                    type="text"
                    value={razaoSocial}
                    onChange={(e) => setRazaoSocial(e.target.value)}
                    placeholder="Informe a razão social"
                  />
                </Form.Group>
                <div className="row">
                  <div className="form-group col-md-3">
                    <label>Porte da Empresa:</label>
                    <select
                      name="porteEmpresa"
                      value={porteEmpresa}
                      onChange={(e) => setPortEmpresa(e.target.value)}
                      className="form-control"
                    >
                      <option value=""> Todos</option>
                      <option value="00"> 00 - NAO INFORMADO</option>
                      <option value="01"> 01 - MICRO EMPRESA</option>
                      <option value="03"> 03 - EMPRESA DE PEQUENO PORTE</option>
                      <option value="05"> 05 - DEMAIS</option>
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label>Forma de Tributação:</label>
                    <select
                      name="formadetributacao"
                      value={formadetributacao}
                      onChange={(e) => setFormadetributacao(e.target.value)}
                      className="form-control"
                    >
                      <option value=""> Todos</option>
                      <option value="3"> Lucro Arbitrado</option>
                      <option value="2"> Lucro Presumido</option>
                      <option value="1"> Lucro Real</option>
                      <option value="4"> Imunes e isentas</option>
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label>Capital Social:</label>
                    <FormControl
                      placeholder="Capital social"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      name="capitalSocial"
                      value={capitalSocial || ""}
                      onChange={(e) => setCapitalSocial(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label>Abertura (Anos):</label>
                    <select
                      name="anosFind"
                      value={anosFind}
                      onChange={(e) => setAnosFind(e.target.value)}
                      className="form-control"
                    >
                      <option value=""> Todos</option>
                      <option value="1"> 1 +</option>
                      <option value="2"> 2 +</option>
                      <option value="3"> 3 +</option>
                      <option value="4"> 4 +</option>
                      <option value="5"> 5 +</option>
                      <option value="10"> 10 +</option>
                      <option value="15"> 15 +</option>
                    </select>
                  </div>
                </div>
                <Form.Group>
                  <TagFilter
                    label={"Atividades (CNAE)"}
                    p_tags={tagsCNAE}
                    p_noSuggestionsText={"Sem sugestões"}
                    p_suggestions={listCNAEsAutocomplete}
                    p_handleAddition={(e) => handleAddition(e, "CNAE")}
                    p_handleDelete={(e) => handleDelete(e, "CNAE")}
                  />
                </Form.Group>
                <Form.Group>
                  <TagFilter
                    label={"Estados"}
                    p_tags={tagsEstado}
                    p_noSuggestionsText={"Sem sugestões"}
                    p_suggestions={listEstadosAutocomplete}
                    p_handleAddition={(e) => handleAddition(e, "ESTADO")}
                    p_handleDelete={(e) => handleDelete(e, "ESTADO")}
                  />
                </Form.Group>
                <Collapse in={tagsEstado.length !== 0}>
                  <Form.Group>
                    <TagFilter
                      label={"Municipios"}
                      p_tags={tagsMunicipio}
                      p_noSuggestionsText={"Sem sugestões"}
                      p_suggestions={listMunicipiosAutocomplete}
                      p_handleAddition={(e) => handleAddition(e, "MUNICIPIO")}
                      p_handleDelete={(e) => handleDelete(e, "MUNICIPIO")}
                    />
                  </Form.Group>
                </Collapse>
                <Form.Group>
                  <Form.Label>Nome Sócio:</Form.Label>
                  <Form.Control
                    type="text"
                    value={nomeSocio || ""}
                    onChange={(e) => setNomeSocio(e.target.value)}
                    placeholder="Informe o nome do sócio"
                  />
                </Form.Group>

                <div className="checkBox">
                  <CheckBoxFilter
                    label={"Listar filiais"}
                    name={"listarFiliais"}
                    checked={listarFiliais}
                    onChange={() => setListarFiliais(!listarFiliais)}
                  />

                  {cnpjLogado === "93578813000144" ? (
                    <>
                      <CheckBoxFilter
                        label={"Listar empresas da base"}
                        name={"listarEmpresasDaBase"}
                        checked={listarEmpresasDaBase}
                        onChange={() => {
                          const listar = !listarEmpresasDaBase;
                          setListarEmpresasDaBase(!listarEmpresasDaBase);

                          if (listar === false) {
                            setDesconsidEmpReservada(false);
                            setDesconsidEmpContatadaUmAno(false);
                          }
                        }}
                      />
                      <CheckBoxFilter
                        label={
                          "Desconsiderar empresas contatas a menos de 1 ano"
                        }
                        name={"desconsiderarEmpContatadasUmAno"}
                        disabled={listarEmpresasDaBase === false}
                        checked={desconsidEmpContatadaUmAno}
                        onChange={() =>
                          setDesconsidEmpContatadaUmAno(
                            !desconsidEmpContatadaUmAno
                          )
                        }
                      />
                      <CheckBoxFilter
                        label={"Desconsiderar empresas reservadas"}
                        disabled={listarEmpresasDaBase == false}
                        name={"desconsidEmpReservada"}
                        checked={desconsidEmpReservada}
                        onChange={() =>
                          setDesconsidEmpReservada(!desconsidEmpReservada)
                        }
                      />
                    </>
                  ) : (
                    <> </>
                  )}

                  <CheckBoxFilter
                    label={"Listar empresas com situação cadastral baixada"}
                    name={"listarEmpresasNaoAtivas"}
                    checked={apenasEmpresasAtivas}
                    onChange={() =>
                      setApenasEmpresasAtivas(!apenasEmpresasAtivas)
                    }
                  />
                </div>
              </div>
            </Collapse>
            <div className="textFilter">
              <p className="filter">Filtros:</p>
              <p className="filterDesc">
                {filter} - Quantidade de registros{" "}
                {findResult === undefined ? 0 : Object.keys(findResult).length}
              </p>
            </div>

            <Button
              variant="none"
              className="buttons"
              onClick={() => handleFind(true)}
            >
              <img src={Lupa} alt=""></img> Buscar
            </Button>
            <Button
              variant="none"
              className="buttons"
              onClick={() => exportCSV()}
            >
              <img src={FileDownload} alt=""></img> Download CSV
            </Button>

            <Button
              variant="none"
              className="buttonClear"
              title="Limpar"
              onClick={() => cleanFilters()}
            >
              <img src={Lixeira} alt=""></img> Limpar filtros
            </Button>

            <Button
              variant="none"
              className="buttonExpand"
              onClick={() => setCollapseOpen(!collapseOpen)}
              aria-controls="example-collapse-text"
              aria-expanded={collapseOpen}
            >
              {collapseOpen ? (
                <>
                  <img src={Recolher} alt="" />
                  Recolher filtros
                </>
              ) : (
                <>
                  <img src={Expandir} alt="" />
                  Expandir filtros
                </>
              )}
            </Button>
          </Form>

          <Noselect>
            <TableResults
              tableResults={findResult}
              expandRow={expandRow}
              columns={columnsTable}
            />

            {findResult.length < 1 ? (
              <div className="no-search">
                <img src={InicioPesquisa} alt=""></img>
                <p>Inicie sua consulta de empresas com os filtros acima!</p>
              </div>
            ) : (
              ""
            )}
            {findResult.length >= 200 && !disableVerMais ? (
              <Button
                variant="none"
                className="buttonMaisEmpresas"
                title="Mais empresas"
                onClick={() => maisEmpresas()}
              >
                Mais resultados
              </Button>
            ) : null}
          </Noselect>
        </Card.Body>
      </Card>
    </>
  );
}
